export { HfdAuthor } from "./pages/hfdAuthorManagement";
